import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedPlusOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M12 1c5.042 0 7.606.346 8.556 2.167-.762-.294-1.593-.492-2.468-.63C16.41 2.274 14.376 2.2 12 2.2s-4.41.073-6.089.338c-.875.137-1.705.335-2.467.629C4.394 1.346 6.958 1 12 1"
                    fill="currentColor"
                />
                <path d="M5 9.1v1.8h14V9.1z" fill="currentColor" />
                <path d="M5.5 14.4h7v-1.8h-7z" fill="currentColor" />
                <path
                    d="M12 4C2.556 4 .226 5.188 1.207 13.5 2.188 21.813 3.537 23 12 23q.517 0 1-.006v-1.8a73 73 0 0 1-1 .006c-2.1 0-3.635-.076-4.798-.287-1.143-.207-1.787-.52-2.215-.897-.426-.375-.812-.966-1.15-2.057-.345-1.114-.599-2.608-.842-4.67-.498-4.215.029-5.603.836-6.26.465-.379 1.248-.716 2.64-.936C7.857 5.876 9.655 5.8 12 5.8s4.144.075 5.528.293c1.393.22 2.176.557 2.641.936.788.641 1.31 1.98.87 5.971h1.81C23.676 5.14 21.25 4 12 4"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 19a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5.9-.9V16h1.8v2.1H22v1.8h-2.1V22h-1.8v-2.1H16v-1.8z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CardLinesStackedPlusOutlinedSize24Glyph.displayName = 'CardLinesStackedPlusOutlinedSize24Glyph';
